import React from "react";
import { assetUrl } from "../../config";
import WebP from "../global/WebP";
import ArrowRight from "../../../assets/svg/arrowRight.svg";
import DefaultScreenshots from "./DefaultScreenshots";

export default function GameScreenshots({ game, clickHandler }) {
  const renderScreenShots = () => {
    if (game.screenshots && game.screenshots.length > 0) {
      return game.screenshots.map((ss) => (
        <WebP secret={`${assetUrl}${ss}`} imgProps={{ alt: game.fullname, fetchPriority: "high" }} key={ss} />
      ));
    }

    return <DefaultScreenshots game={game} />;
  };

  return (
    <div onClick={clickHandler} tabIndex={1} className="game-screenshots" data-testid="game-screenshots">
      {renderScreenShots()}
      <button type="button" className="playbutton button-flat-color orange dimensional">
        <ArrowRight />
      </button>
    </div>
  );
}
